module.exports = __webpack_public_path__ + "img/ic_cow_border.af201df0.png";